"use strict";function pause$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.pause$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="media.voiceRecorder.pause";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"5.1.12"},_a[ddSdk_1.ENV_ENUM.android]={vs:"5.1.12"},_a[ddSdk_1.ENV_ENUM.pc]={vs:"5.1.12"},_a)),exports.pause$=pause$,exports.default=pause$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/media/voiceRecorder/pause.js
// module id = 1081
// module chunks = 106